import React from 'react';
import { mdiFlaskOutline, mdiFormatListChecks, mdiPlayCircleOutline, mdiVideoAccount } from '@mdi/js';
import Icon from '@mdi/react';
import pluralize from 'pluralize';
import styled from 'styled-components';
import { IconSize } from '../../lib';
import { CourseIconPath } from '../Icons/CourseIcon';
import { SkillIconPath } from '../Icons/SkillIcon';
export var StatTypes;
(function (StatTypes) {
    StatTypes["Skills"] = "Skill";
    StatTypes["Labs"] = "Virtual Lab";
    StatTypes["Videos"] = "Video";
    StatTypes["Questions"] = "Question";
    StatTypes["LiveLearning"] = "Live Learning Session";
    StatTypes["Collections"] = "Collection";
})(StatTypes || (StatTypes = {}));
const StatIcons = {
    Skill: SkillIconPath,
    'Virtual Lab': mdiFlaskOutline,
    Video: mdiPlayCircleOutline,
    Question: mdiFormatListChecks,
    'Live Learning Session': mdiVideoAccount,
    Collection: CourseIconPath
};
const StatIcon = styled.div `
    width: ${IconSize.Small};
    margin-right: 0.25rem;
`;
const StatCount = styled.span `
    line-height: 20px;
    margin-right: 0.25rem;
`;
const StatType = styled.span `
    letter-spacing: 0.09px;
    line-height: 20px;
`;
const StatContainer = styled.div `
    display: flex;
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
    color: #8b959c;
`;
export const MarketplaceStat = ({ statType, statCount }) => {
    const matchingStatIconPath = StatIcons[statType];
    return (React.createElement(StatContainer, null,
        React.createElement(StatIcon, null,
            React.createElement(Icon, { path: matchingStatIconPath })),
        React.createElement(StatCount, null, statCount),
        " ",
        React.createElement(StatType, null, pluralize(statType, statCount))));
};
//# sourceMappingURL=MarketPlacestat.js.map